(function ($, Drupal,drupalSettings) {
  Drupal.behaviors.bootstrap_barrio_subtheme = {
    attach: function (context, settings) {
    $(document).ready(function() {

		$('.logo').css('background-image','url("/themes/custom/tmyk/images/TMYK.png")');
		//$('.logo').css('width','350px');
		$('.logo').css('background-size','contain');
		$('.logo2').css('background-image','url("/themes/custom/tmyk/images/TMYSH-white.svg")');
		$('.topic-filter .select-items a:first').addClass('same-as-selected');
        $('.talent-filter .select-items a:first').addClass('same-as-selected');

		$(".topic-filter .select-selected").click(function(){
		  if($('.topic-filter .select-items a:first').html() != 'ALL TOPICS'){
		    $('.topic-filter .select-items a:first').html('ALL TOPICS');
			$('.topic-filter select option:first-child').text('ALL TOPICS');
		  }
        });

		$(document).on('keydown',function(event){
			if(event.which == 40){
				$('.select-items a:focus').next().focus();
			}
			if(event.which == 38){
				$('.select-items a:focus').prev().focus();
			}
			if(event.which == 13){
				if($('.select-items').is(':visible')){
					document.querySelector('.select-items a:focus').click();
				}
			}
		});

		// Init ScrollMagic
		var controller = new ScrollMagic.Controller();

		// build a scene
		var ourScene = new ScrollMagic.Scene({
			triggerElement: '#main',

			triggerHook: .1,
		})
		.setClassToggle('#menu', 'menu-anim') // add class to project01
		// .addIndicators({
		// 	name: 'header',
		// 	colorTrigger: 'red',
		// 	indent: 200,
		// 	colorStart: '#75C695'
		// }) // this requires a plugin
		.addTo(controller);

		var mobFrameSet = false;
		$(window).on('scroll',function(){
			$("iframe").each(function() {
			  $(this)[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
			});
			if(jQuery(window).width() <= 480 && jQuery('body').hasClass('path-videos')){
				tmyk.videoGrid_1_load = 1;
				tmyk.videoGrid_1(false);
				jQuery('.video_image.removePlay_icon').removeClass('removePlay_icon');
				jQuery('.hq-default.hide').removeClass('hide');
			}
		});
    });
    }
  };
})(jQuery, Drupal,drupalSettings);

var video_Grid_active = 3;
jQuery(document).ready(function() {
	//Tablet Menu changes
	jQuery( window ).on( "orientationchange", function( event ) {
		setTimeout(function(){
			if(jQuery(window).width() <= 768){
				if(jQuery('#myNav').width() != 0){
					document.getElementById("myNav").style.transition = "0.1s";
					document.getElementById("myNav").style.width = "0%";
					document.getElementById("myNav-mobile").style.transition = "0.5s";
					document.getElementById("myNav-mobile").style.width = "100%";
					jQuery('header').css('z-index','1000');
				}
			}else if((jQuery(window).width() <= 1250) && (jQuery(window).width() >= 769)){
				if(jQuery('#myNav-mobile').width() != 0){
					document.getElementById("myNav-mobile").style.transition = "0.1s";
					document.getElementById("myNav-mobile").style.width = "0%";
					document.getElementById("myNav").style.transition = "0.5s";
					document.getElementById("myNav").style.width = "35%";
				}
			}
		},0)
	});

	jQuery(window).resize(function(){
		if(jQuery('#myNav').width() != 0){
			if((jQuery(window).width() <= 1250) && (jQuery(window).width() >= 769)){
				document.getElementById("myNav").style.width = "35%";
			}else if(jQuery(window).width() >= 1251){
				document.getElementById("myNav").style.width = "30%";
			}
		}
		setTimeout(function(){
			if(jQuery(window).width() >= 768){
				tmyk.videoGrid_3_load = 1;
				tmyk.videoGrid_3(false);
			}else if(jQuery(window).width() <= 767 && jQuery(window).width() >=480){
					tmyk.videoGrid_2_load = 1;
					tmyk.videoGrid_2(false);
			}
			else {
				tmyk.videoGrid_1_load = 1;
				tmyk.videoGrid_1(false);
				jQuery('removePlay_icon').removeClass('removePlay_icon');
				jQuery('.hq-default.hide').removeClass('hide');
			}
		},350);

	});
	setTimeout(function(){
		if(jQuery(window).width() >= 768){
			tmyk.videoGrid_3(false);
		}else if(jQuery(window).width() <= 767 && jQuery(window).width() >=480 ){
			tmyk.videoGrid_2(false);
		}
		else {
			tmyk.videoGrid_1(false);
		}
		jQuery('.view-videos .psa_video_container').css('visibility','visible');
	},1000);

	jQuery(document).on('click', '.iframe-overlay', function() {

		videoId = jQuery(".video-container iframe").attr("src");

		if(jQuery(window).width() < 480){
			var iframeE = '<iframe width="100%" height="100%" src="'+videoId+'?autoplay=1&enablejsapi=1&rel=0" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" allow="autoplay"></iframe>';
			jQuery(this).addClass('removePlay_icon');
			jQuery(this).addClass('iframe-loaded').append(iframeE);
			jQuery(this).find('img').addClass('hide');
			var current = jQuery(this);
		}else{
		  document.getElementById('psaIframeId').src = videoId+ '?autoplay=1&rel=0';
		  jQuery('#psaVideoModal').removeClass('one out');
		  setTimeout(function(){
		    jQuery('#psaVideoModal').addClass('one');
			jQuery('body').addClass('modal-active');
		  },300);
		}
    });
	jQuery(document).on('click', '.psa_video_container .video_image', function() {
		var parent_cont = jQuery(this).parents('.psa_video_container');
		videoId = 'https://www.youtube.com/embed/'+parent_cont.data('id');
		if(jQuery(window).width() < 480){
			var iframeE = '<iframe width="100%" height="100%" src="'+videoId+'?autoplay=1&enablejsapi=1&rel=0" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" allow="autoplay"></iframe>';
			jQuery(this).addClass('removePlay_icon');
			jQuery(this).addClass('iframe-loaded').append(iframeE);
			jQuery(this).find('img').addClass('hide');
			var current = jQuery(this);
			/*setTimeout(function(){
				current.find('img').addClass('hide');
				current.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
			},1000);*/
		}else {
			document.getElementById('psaIframeId').src = videoId+ '?autoplay=1&rel=0';
			jQuery('#psaVideoModal').removeClass('one out');
			setTimeout(function(){
				jQuery('#psaVideoModal').addClass('one');
				jQuery('body').addClass('modal-active');
			},300);
		}
	});
});
var tmyk = {
	videoGrid_3_load: 1,
	grid_3_Image_height: function(){
		//jQuery('.view-videos .psa_video_container .video_image .hq-default').removeClass('hide');
		//jQuery('.video_image .sd-default, .video_image .max-default').addClass('hide');
		jQuery('.view-videos .psa_video_container').each(function(){
			var src = jQuery(this).find('.video_image .hq-default').attr('src');
			var res = src.split("/");
			res[5]='hqdefault.jpg';
			var res1 = res.join('/');
			jQuery(this).find('.video_image .hq-default').attr('src',res1);
		});
		var imageSelector = jQuery('.view-videos .psa_video_container .video_image');
		var imageHeight = imageSelector.width() / 1.777777778 ;
		imageSelector.css('height',imageHeight);
	},
	videoGrid_3: function(scrollFlag, data){
		var gridColWidth = (jQuery('.view-videos .grid').width())/3 ;
		if(!scrollFlag){
			jQuery('.view-videos .psa_video_container').css('width',(gridColWidth -15));
		}
		var videoContainer = jQuery('.view-videos .grid .psa_video_container')
		var gridColLength = videoContainer.length;
		//videoContainer.css('width',(gridColWidth -20)+'px');
		this.grid_3_Image_height();
		var gridColheight = videoContainer.height() + 20;
		if(!scrollFlag){
			var multiVal = 1;
			for(var i=1;i<=gridColLength;i++){
				var value = 0;
				var iVal = i;
				if((iVal-3) > 0){
					value = gridColheight + 17;
					if(i >= 7){
						if(Math.abs(i % 3) == 1){
							multiVal++;
							this.videoGrid_3_load++;
						}
						value = (gridColheight *multiVal) + 20;
					}
				}else{
					value = 20;
				}
				if(jQuery(window).width() > 1903){
					if(i%3 == 1){
						jQuery('.view-videos .grid .psa_video_container:nth-child('+i+')').css('transform', 'translate(15px,'+value+'px) scale(1)').css('width',(gridColWidth -15)+'px');
					}else if(i%3 == 2){
						jQuery('.view-videos .grid .psa_video_container:nth-child('+i+')').css('transform', 'translate('+(gridColWidth + 20)+'px,'+value+'px) scale(1)').css('width',(gridColWidth -10)+'px');
					}else if(i%3 == 0){
						jQuery('.view-videos .grid .psa_video_container:nth-child('+i+')').css('transform', 'translate('+((gridColWidth*2) + 30)+'px,'+value+'px) scale(1)').css('width',(gridColWidth - 20)+'px');
					}
				}else{
					if(i%3 == 1){
						jQuery('.view-videos .grid .psa_video_container:nth-child('+i+')').css('transform', 'translate(15px,'+value+'px) scale(1)').css('width',(gridColWidth -20)+'px');
					}else if(i%3 == 2){
						jQuery('.view-videos .grid .psa_video_container:nth-child('+i+')').css('transform', 'translate('+(gridColWidth + 15)+'px,'+value+'px) scale(1)').css('width',(gridColWidth -15)+'px');
					}else if(i%3 == 0){
						jQuery('.view-videos .grid .psa_video_container:nth-child('+i+')').css('transform', 'translate('+((gridColWidth*2) + 20)+'px,'+value+'px) scale(1)').css('width',(gridColWidth - 20)+'px');
					}
				}
			}
		}else {
			var gridhtml = jQuery(data);
			this.grid_3_Image_height();
			var gridCol = gridhtml.find('.psa_video_container').length;
			var colHeight = 0;
			var loopVal = true;
			if(isNaN(gridColheight)){
				colHeight = jQuery('.view-videos .duploicateGrid .psa_video_container').height() + 20;
				loopVal = false;
			}else {
				colHeight = gridColheight;
				loopVal = true;
			}
			var multiVal = 1;
			for(var i=1;i<=gridCol;i++){
				var value = 0;
				if(loopVal){
					if(Math.abs(i% 3) == 1){
						this.videoGrid_3_load++;
					}
					value = (colHeight * this.videoGrid_3_load) + 20;
				}else{
					var iVal = i;
					if((iVal-3) > 0){
						value = colHeight + 17;
						if(i >= 7){
							if(Math.abs(i % 3) == 1){
								multiVal++;
								this.videoGrid_3_load++;
							}
							value = (colHeight *multiVal) + 20;
						}
					}else{
						value = 20;
					}
				}
				if(jQuery(window).width() > 1903){
					if(i%3 == 1){
						gridhtml.find('.psa_video_container:nth-child('+i+')').css('transform', 'translate(15px,'+value+'px) scale(1)').css('width',(gridColWidth -15)+'px');
					}else if(i%3 == 2){
						gridhtml.find('.psa_video_container:nth-child('+i+')').css('transform', 'translate('+(gridColWidth + 20)+'px,'+value+'px) scale(1)').css('width',(gridColWidth -10)+'px');
					}else if(i%3 == 0){
						gridhtml.find('.psa_video_container:nth-child('+i+')').css('transform', 'translate('+((gridColWidth*2) + 30)+'px,'+value+'px) scale(1)').css('width',(gridColWidth - 20)+'px');
					}
				}else {
					if(i%3 == 1){
						gridhtml.find('.psa_video_container:nth-child('+i+')').css('transform', 'translate(15px,'+value+'px) scale(1)').css('width',(gridColWidth -20)+'px');
					}else if(i%3 == 2){
						gridhtml.find('.psa_video_container:nth-child('+i+')').css('transform', 'translate('+(gridColWidth + 15)+'px,'+value+'px) scale(1)').css('width',(gridColWidth -15)+'px');
					}else if(i%3 == 0){
						gridhtml.find('.psa_video_container:nth-child('+i+')').css('transform', 'translate('+((gridColWidth*2) + 20)+'px,'+value+'px) scale(1)').css('width',(gridColWidth - 20)+'px');
					}
				}
			}
			var html = gridhtml. html();
			jQuery(document).find('.ajax-data').before(html);
		}
		var rowLegnth = Math.ceil(jQuery('.view-videos .grid .psa_video_container').length/3);
		jQuery('.view-videos .grid').css('height',((jQuery('.view-videos .grid .psa_video_container').height() + 20)* rowLegnth + 100)+'px');
		jQuery('.view-videos .psa_video_container .video_image').removeClass('grid_play_1');
		this.grid_3_Image_height();
		video_Grid_active = 3;
	},
	videoGrid_2_load: 1,
	grid_2_Image_height: function(){
		//jQuery('.view-videos .psa_video_container .video_image .sd-default').removeClass('hide');
		//jQuery('.video_image .hq-default, .video_image .max-default').addClass('hide');
		jQuery('.view-videos .psa_video_container').each(function(){
			var src = jQuery(this).find('.video_image .hq-default').attr('src');
			var res = src.split("/");
			res[5]='sddefault.jpg';
			var res1 = res.join('/');
			jQuery(this).find('.video_image .hq-default').attr('src',res1);
		});
		var imageSelector = jQuery('.view-videos .psa_video_container .video_image');
		var imageHeight = imageSelector.width() / 1.777777778 ;
		imageSelector.css('height',imageHeight);
	},
	videoGrid_2: function(scrollFlag, data){
		var gridColWidth =  (jQuery('.view-videos .grid').width())/2;
		if(!scrollFlag){
			jQuery('.view-videos .psa_video_container').css('width',(gridColWidth -15));
		}
		var videoContainer = jQuery('.view-videos .grid .psa_video_container')
		var gridColLength = videoContainer.length;
		//videoContainer.css('width',(gridColWidth -20)+'px');
		this.grid_2_Image_height();
		var gridColheight = videoContainer.height() + 20;
		if(!scrollFlag){
			var multiVal = 1;
			for(var i=1;i<=gridColLength;i++){
				var value = 0;
				var iVal = i;
				if((iVal-2) > 0){
					value = gridColheight + 20;
					if(i >= 5){
						if(Math.abs(i % 2) == 1){
							multiVal++;
							this.videoGrid_2_load++;
						}
						value = (gridColheight *multiVal) + 20;
					}
				}else{
					value = 20;
				}
				if(i%2 == 1){
					jQuery('.view-videos .grid .psa_video_container:nth-child('+i+')').css('transform', 'translate(15px,'+value+'px) scale(1)').css('width',(gridColWidth - 15)+'px');
				}else if(i%2 == 0){
					jQuery('.view-videos .grid .psa_video_container:nth-child('+i+')').css('transform', 'translate('+(gridColWidth + 20)+'px,'+value+'px) scale(1)').css('width',(gridColWidth - 25)+'px');
				}
			}
		}else {
			var gridhtml = jQuery(data);
			this.grid_2_Image_height();
			var gridCol = gridhtml.find('.psa_video_container').length;
			var colHeight = 0;
			var loopVal = true;
			if(isNaN(gridColheight)){
				colHeight = jQuery('.view-videos .duploicateGrid .psa_video_container').height() + 20;
				loopVal = false;
			}else {
				colHeight = gridColheight;
				loopVal = true;
			}
			var multiVal = 1;
			for(var i=1;i<=gridCol;i++){
				var value = 0;
				if(loopVal){
					if(Math.abs(i% 2) == 1){
						this.videoGrid_2_load++;
					}
					value = (colHeight * this.videoGrid_2_load) + 20;
				}else{
					var iVal = i;
					if((iVal-2) > 0){
						value = colHeight + 20;
						if(i >= 5){
							if(Math.abs(i % 2) == 1){
								multiVal++;
								this.videoGrid_2_load++;
							}
							value = (colHeight *multiVal) + 20;
						}
					}else{
						value = 20;
					}
				}
				if(i%2 == 1){
					gridhtml.find('.psa_video_container:nth-child('+i+')').css('transform', 'translate(15px,'+value+'px) scale(1)').css('width',(gridColWidth - 15)+'px');
				}else if(i%2 == 0){
					gridhtml.find('.psa_video_container:nth-child('+i+')').css('transform', 'translate('+(gridColWidth + 20)+'px,'+value+'px) scale(1)').css('width',(gridColWidth - 25)+'px');
				}
			}
			var html = gridhtml. html();
			jQuery(document).find('.ajax-data').before(html);
		}
		var rowLegnth = Math.ceil(jQuery('.view-videos .grid .psa_video_container').length/2);
		jQuery('.view-videos .grid').css('height',(( jQuery('.view-videos .duploicateGrid .psa_video_container').height() + 20)* rowLegnth + 100)+'px');
		jQuery('.view-videos .psa_video_container .video_image').removeClass('grid_play_1');
		this.grid_2_Image_height();
		video_Grid_active = 2;
	},
	videoGrid_1_load: 1,
	grid_1_Image_height: function(){
		//jQuery('.view-videos .psa_video_container .video_image .max-default').removeClass('hide');
		jQuery('.view-videos .psa_video_container .video_image').removeClass('iframe-loaded').find('iframe').remove();
		//jQuery('.video_image .hq-default, .video_image .sd-default').addClass('hide');
		jQuery('.view-videos .psa_video_container').each(function(){
			var src = jQuery(this).find('.video_image .hq-default').attr('src');
			var res = src.split("/");
			res[5]='maxresdefault.jpg';
			var res1 = res.join('/');
			jQuery(this).find('.video_image .hq-default').attr('src',res1);
		});
		var imageSelector = jQuery('.view-videos .psa_video_container .video_image');
		var imageHeight = imageSelector.width() / 1.777777778 ;
		imageSelector.css('height',imageHeight);
	},
	videoGrid_1: function(scrollFlag, data){
		var gridColWidth = jQuery('.view-videos .grid').width();
		if(!scrollFlag){
			jQuery('.view-videos .psa_video_container').css('width',(gridColWidth - 20));
		}
		var videoContainer = jQuery('.view-videos .grid .psa_video_container');
		var gridColLength = videoContainer.length;
		//videoContainer.css('width',(gridColWidth - 20)+'px');
		this.grid_1_Image_height();
		var gridColheight = videoContainer.height() + 20;
		if(!scrollFlag){
			var multiVal = 1;
			for(var i=0;i<gridColLength;i++){
				var value = 0;
				var iVal = i;
				if(i > 0){
					value = gridColheight + 17;
					if(i >= 2){
						multiVal++;
						this.videoGrid_1_load++;
						value = (gridColheight *multiVal) + 20;
					}
				}else{
					value = 20;
				}
				jQuery('.view-videos .grid .psa_video_container:nth-child('+(i+ 1)+')').css('transform', 'translate(15px,'+value+'px) scale(1)');
			}
		}else {
			var gridhtml = jQuery(data);
			this.grid_1_Image_height();
			var gridCol = gridhtml.find('.psa_video_container').length;
			var colHeight = 0;
			var loopVal = true;
			if(isNaN(gridColheight)){
				colHeight = jQuery('.view-videos .duploicateGrid .psa_video_container').height() + 20;
				loopVal = false;
			}else {
				colHeight = gridColheight;
				loopVal = true;
			}
			var multiVal = 1;
			for(var i=0;i<gridCol;i++){
				var value = 0;
				if(loopVal){
					this.videoGrid_1_load++;
					value = (colHeight * this.videoGrid_1_load) + 20;
				}else{
					var iVal = i;
					if(i > 0){
						value = colHeight + 17;
						if(i >= 2){
							multiVal++;
							this.videoGrid_1_load++;
							value = (colHeight *multiVal) + 20;
						}
					}else{
						value = 20;
					}
				}
				gridhtml.find('.psa_video_container:nth-child('+(i+ 1)+')').css('transform', 'translate(15px,'+value+'px) scale(1)');
			}
			var html = gridhtml. html();
			jQuery(document).find('.ajax-data').before(html);
		}
		jQuery('.view-videos .grid .psa_video_container').css('width',(gridColWidth - 15)+'px');
		if(jQuery(window).width() >= 768){
		  jQuery('.view-videos .grid').css('height',(( jQuery('.view-videos .duploicateGrid .psa_video_container').height() + 20)* ( jQuery('.view-videos .grid .psa_video_container').length) + 100)+'px');
		}
		else{
		 jQuery('.view-videos .grid').css('height',(( jQuery('.view-videos .grid .psa_video_container').height() + 20)* ( jQuery('.view-videos .grid .psa_video_container').length) + 100)+'px');
		}
		this.grid_1_Image_height();
		jQuery('header').css('width','auto').css('width','100%');
		video_Grid_active = 1;
	},
	hidePopup_psaVideo:function(){
		document.getElementById('psaIframeId').src = '';
		jQuery('#psaVideoModal').addClass('out');
		jQuery('body').removeClass('modal-active');
	},
	HomePage_AppendImage: function(urlList){
		if(Array.isArray(urlList)){
			if(urlList.length !=0){
				var listLength = 0;
				var interval =  setInterval(function(){
					var append_html = '<div class="slideshow-image" style="background-image: url('+urlList[listLength]+')"></div>';
					jQuery('.node--type-homepage').find('.slideshow').append(append_html);
					listLength++;
					if(listLength == urlList.length){
						tmyk.clear_interval(interval);
					}
				}, 50);
			}
		}
	},
	clear_interval: function(intervalFUN){
		clearInterval(intervalFUN);
	},
	loadHomePageCSS:function(slidesNo){
		var items = slidesNo-5;
		var animationtime = 4; //4s
		var transitiontime=  .5; // .5s
		var scale = 20;
		var totaltime = (animationtime * items);
		var scalebase= (1 + scale / 100);
		var slideshowArr = ['.slideshow-image {  position: absolute;  width: 100%;  height: 100%;  background: no-repeat 100% 0;  background-size: cover;  animation-name: kenburns;  animation-timing-function: linear;  animation-iteration-count:infinite;  animation-duration: '+totaltime+'s;  opacity: 1;  transform: scale('+scalebase+');-webkit-transform: scale('+scalebase+');}'];

		for(var i=6;i<=slidesNo;i++){
			var slide = '.slideshow-image:nth-child('+i+') {animation-name: kenburns-'+i+';z-index: '+(slidesNo - i)+';}';
			slideshowArr.push(slide);
		}

		for(var j=6;j<=slidesNo;j++){
			var animation = ['@keyframes kenburns-'+j+' {'];
			var animationtimepercent = (animationtime / totaltime);
			var transitiontimepercent = (transitiontime / totaltime);
			var t1 = (animationtimepercent * (j - 1) - transitiontimepercent / 2)*100;
			var t2 = (animationtimepercent * (j - 1) + transitiontimepercent / 2) * 100;
			if(t1 < 0) { t1= 0; }
			if(t2 < 0) { t2= 0; }
			var t3 = (animationtimepercent * j - transitiontimepercent / 2)* 100;
			var t4 = (animationtimepercent * j + transitiontimepercent / 2)* 100;
			if(t3 > 100) { t3= 100; }
			if(t4 > 100) { t4= 100; }
			var t5 = (100 - transitiontimepercent / 2);
			var t6 = ((t4 - t1) * 100 / t5);
			var anim = t1+'% { opacity: 1; transform: scale('+scalebase+'); -webkit-transform: scale('+scalebase+');}'+t2+'% { opacity: 1; }'+t3+'% { opacity: 1; }'+t4+'% { opacity: 0;transform: scale(1);-webkit-transform: scale(1); }';
			animation.push(anim);
			if(j != slidesNo){
			var anim = '100% { opacity: 0; transform: scale('+scalebase+'); -webkit-transform: scale('+scalebase+'); }';
			animation.push(anim);
			}
			if(j == 1){
				var scaleplus = (scale * (100 - t5) / t4);
				var scaleplusbase = (1 + (scale + scaleplus) / 100);
				var anim = t5+'% { opacity: 0; transform: scale('+scaleplusbase+');-webkit-transform: scale('+scaleplusbase+'); } 100% { opacity: 1; }';
				animation.push(anim);
			}
			animation.push('}');
			var sli = animation.join('');
			slideshowArr.push(sli);
		}

		var sli = slideshowArr.join('');
		var sheet = document.createElement('style')
		sheet.innerHTML = sli;
		document.body.appendChild(sheet);
	}
}
/* Open when someone clicks on the span element */

function openNav() {
	if((jQuery(window).width() >= 769) && (jQuery(window).width() <= 1250)) {
		document.getElementById("myNav").style.width = "35%";
	}else {
		document.getElementById("myNav").style.width = "30%";
	}
	document.getElementById("myNav").style.transition = "0.5s";
	jQuery('#myNav .container-menu-close').css('width','100%');
}

/* Close when someone clicks on the "x" symbol inside the overlay */
function closeNav() {
	document.getElementById("myNav").style.width = "0%";
	jQuery('#myNav .container-menu-close').css('width','0%');
}

/* Open when someone clicks on the span element */
function openNav2() {
	document.getElementById("myNav-mobile").style.width = "100%";
	document.getElementById("myNav-mobile").style.transition = "0.5s";
	jQuery('#myNav-mobile .container-menu-close').css('width','100%');
	jQuery('header').css('z-index','1000');
}

/* Close when someone clicks on the "x" symbol inside the overlay */
function closeNav2() {
	document.getElementById("myNav-mobile").style.width = "0%";
	jQuery('#myNav-mobile .container-menu-close').css('width','0%');
	jQuery('header').css('z-index','200');
}

var focusFlag = false;


var x, i, j, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select-filter": */
x = document.getElementsByClassName("custom-select-filter");
for (i = 0; i < x.length; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  var idCre = x[i].attributes.name.nodeValue;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("BUTTON");
  a.setAttribute("class", "select-selected");
  a.setAttribute("tabindex", (i+1));
  a.setAttribute("id", idCre);
  a.setAttribute("type", 'button');
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  b.setAttribute("aria-labelledby", idCre);

  for (j = 0; j < selElmnt.length; j++) {
	/* For each option in the original select element,
	create a new DIV that will act as an option item: */
	c = document.createElement("A");
	c.setAttribute("tabindex", (j+1));
	c.innerHTML = selElmnt.options[j].innerHTML;
	c.addEventListener("click", function(e) {
		/* When an item is clicked, update the original select box,
		and the selected item: */
		var y, i, k, s, h;
		s = this.parentNode.parentNode.getElementsByTagName("select")[0];
		h = this.parentNode.previousSibling;
		for (i = 0; i < s.length; i++) {
		  if (s.options[i].innerHTML == this.innerHTML) {
			s.selectedIndex = i;
			h.innerHTML = this.innerHTML;
			y = this.parentNode.getElementsByClassName("same-as-selected");
			for (k = 0; k < y.length; k++) {
			  y[k].removeAttribute("class");
			}
			this.setAttribute("class", "same-as-selected");
			break;
		  }
		}
		h.click();
	});
	b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
	/* When the select box is clicked, close any other select boxes,
	and open/close the current select box: */
	focusFlag = true;
	e.stopPropagation();
	closeAllSelect(this);
	this.nextSibling.classList.toggle("select-hide");
	this.classList.toggle("select-arrow-active");
	jQuery('.select-items .same-as-selected').focus();
  });
}



function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}
/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);

/*var coll = document.getElementsByClassName("collapsible");
var i;*/
jQuery(".collapsible").click(function() {
	jQuery('.collapsible').removeClass('active');
    if(jQuery('.collapsible-section .content').is(':visible')) {
     jQuery(".collapsible-section .content").slideUp(300);
     jQuery('.collapsible').find(".collapsible-icon-minus").hide();
	 jQuery('.collapsible').find(".collapsible-icon-plus").show();
    }
    if(jQuery(this).next(".collapsible-section .content").is(':visible')) {
      jQuery(this).next(".collapsible-section .content").slideUp(300);
      jQuery('.collapsible').find(".collapsible-icon-minus").hide();
	  jQuery('.collapsible').find(".collapsible-icon-plus").show();
    } else {
      jQuery(this).next(".collapsible-section .content").slideDown(300);
      jQuery(this).find(".collapsible-icon-plus").hide();
	  jQuery(this).find(".collapsible-icon-minus").show();
	  jQuery(this).addClass('active');
	  var obj = jQuery(this);
      setTimeout(function(){
        jQuery('html, body.content').animate({
                scrollTop: obj.offset().top - 100
              }, 300);
      }, 300);
    }
  });
